import React, { FC } from 'react';
import { SelectProps } from 'antd';

import { Select } from '~/components';
import { useHandbook, useHandbookKeys } from '~/controllers/handbook';

const RelationSelect: FC<SelectProps<any>> = (props) => {
  const handbook = useHandbook();
  const handbookKeys = useHandbookKeys();
  const options = handbook.data?.handbooks
    ?.find((item) => item.key === handbookKeys.relation)
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    ?.values?.map((item) => ({ label: item.localizedValue, value: item.apiValue!, key: item.key }));

  return (
    <Select
      loading={handbook.isLoading}
      disabled={handbook.isLoading}
      options={options}
      {...props}
    />
  );
};

export default RelationSelect;
